<template>
  <div>
    <PageHeader title="مدیریت دانشکده" :items="pageHeaderItems" />
    <Loader v-if="loading" />
    <b-row v-else>
      <b-col cols="12" md="4">
        <div class="inner__style">
          <div v-if="model.image.length === 0" class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center" @click="$bvModal.show('cropperModal')">
            <div>
              <i class="fas fa-cloud-upload-alt icon-size"></i>
              <div class="upload-text-size">عکس بنر خود را انتخاب کنید</div>
            </div>
          </div>
          <div v-else class="grand-parent">
            <div class="upload-photo-parent">
              <div class="uploaded-photo">
                <div class="remove-icon" @click="model.image = ''">
                  <i class="fa fa-times"></i>
                </div>
                <img class="previewImage" :src="model.image" />
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="8">
        <div class="card">
          <Section title="اطلاعات دانشکده">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.faclultyPhoneNumber" @input="model.faclultyPhoneNumber = $event" title="تلفن" placeholder="تلفن" />
            </div>
            <div class="my-3">
              <TextAreaInput :maxlength="2000" :value="model.facultyAddress" @input="model.facultyAddress = $event" title="آدرس" placeholder="آدرس" />
            </div>
          </Section>
          <Section title="تنظیمات صفحه">
            <div class="section-title">ترتیب نمایش در صفحه</div>
            <Radio :componentData="sorts" :value="model.sortType" @input="model.sortType = $event" />
          </Section>
        </div>
        <div class="card p-3 d-flex flex-row justify-content-end">
          <b-button @click="$router.push('/list/universityfaculties')">انصراف</b-button>
          <b-button variant="primary ms-2 px-5" @click="addFaculty">ثبت</b-button>
        </div>
      </b-col>
    </b-row>
    <Toast :title="message" :error="error" :showToast="message !== ''" />
    <b-modal id="cropperModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
      <template #modal-title>کراپ عکس</template>
      <div class="p-3">
        <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="uploadImage($event)" :cropSize="imageCrop" cropShape="rectangle-stencil"> </ImageCropper>
      </div>
    </b-modal>
  </div>
</template>
<script>
import PageHeader from '../../../layoutComponents/page-header.vue'
import BaseText from '../../../common/form/formModules/BaseText.vue'
import fileMannager from '../../../../services/file'
import moocFacultysProvider from '../../../../services/mooc/faculty'
import Toast from '../../../common/Toast.vue'
import Loader from '../../../widgets/loader.vue'
import ImageCropper from '../../../user/ImageCropper.vue'
import Section from '../../../common/form/Section.vue'
import TextAreaInput from '../../../common/form/formModules/TextAreaInput.vue'
import Radio from '../../../common/form/formModules/Radio.vue'
export default {
  name: 'AddFaculty',
  components: { PageHeader, BaseText, Toast, Loader, ImageCropper, Section, TextAreaInput, Radio },
  props: {
    create: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imageCrop: { width: 400, height: 200 },
      model: {
        id: 0,
        image: '',
        faclultyPhoneNumber: '',
        facultyAddress: '',
        sortType: 0,
      },
      message: '',
      cropperLoading: false,
      submit: false,
      error: false,
      loading: false,
      sorts: [
        { value: 'تک درس', key: 0 },
        { value: 'دوره', key: 1 },
      ],

      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت دانشکده', active: true },
      ],
    }
  },
  async mounted() {
    if (this.update) {
      this.fetchFaculty()
    }
  },
  methods: {
    async addFaculty() {
      this.loading = true

      try {
        if (this.update) {
          // this.model.id = +this.$route.params.id
          const req = await moocFacultysProvider.updateExtraFaculty(this.model)
          if (req.status === 200) {
            this.message = 'اطلاعات با موفقیت ثبت شد.'
          } else {
            this.error = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
          this.loading = false
          return false
        }
      } catch (error) {
        this.loading = false
      }
    },
    async fetchFaculty() {
      this.loading = true
      try {
        const req = await moocFacultysProvider.getExtraFaculty()
        this.model = req.data.data.output
        if (this.model.sortType === null) {
          this.model.sortType = 0
        }
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async uploadImage(e) {
      this.cropperLoading = true
      const req = await fileMannager.addImage({
        base64image: e,
      })
      this.model.image = req.data.data.downloadUrl
      this.cropperLoading = false
      this.$bvModal.hide('cropperModal')
    },
  },
}
</script>
<style lang="scss" scoped>
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.sections {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 1rem;
}

.image {
  border-radius: 100%;
  width: 200px;
  height: 200px;
  margin: auto;
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo {
  height: 200px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
    // font-size: 20px;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    // font-size: 18px;
    color: #ff4861;
    // font-weight: 100;
  }
}
.previewImage {
  border-radius: 4px;
}
.checkbox-margin {
  margin-right: 8px;
}

::v-deep .custom-control-label {
  margin-right: 10px !important;
}

::v-deep .custom-control-input {
  border: 1px solid #556ee6 !important;
}

::v-deep .b-form-tags-button {
  display: none;
}
.part {
  display: inline-flex;
  width: 50%;
}

.upload-photo-parent {
  width: 100%;
}
</style>
